
    import Ember from 'ember';
    import "coffeescripts/ember/shared/helpers/common";
import "i18n!screenreader_gradebook.gradebook_header";

    Ember.TEMPLATES['gradebookHeader'] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data
) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  data.buffer.push("\n\n\n<div class=\"row-fluid\">\n  <div class=\"span12\">\n    <h1>");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "gradebook_individual_view_8846598e", "Gradebook: Individual View", options) : helperMissing.call(depth0, "t", "gradebook_individual_view_8846598e", "Gradebook: Individual View", options))));
  data.buffer.push("</h1>\n      ");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "note_grades_and_notes_will_be_saved_automatically__e3270872", "Note: Grades and notes will be saved automatically after moving out of the field.", options) : helperMissing.call(depth0, "t", "note_grades_and_notes_will_be_saved_automatically__e3270872", "Note: Grades and notes will be saved automatically after moving out of the field.", options))));
  data.buffer.push("\n  </div>\n</div>\n");
  return buffer;
  
});
  